import { IAgregarUsuarioLectora } from '../models/interfaces';

export const UsuarioLectoraDefault: IAgregarUsuarioLectora = {
	userName: '',
	idObraProyecto: 0,
};
